export const setBookedTokenDetails = (data) => {
  return {
    type: "SET_BOOKING_DETAILS",
    payload: {
      data,
    },
  };
};
